import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Button } from "reactstrap";

const CoCard = ({ items, ccoNo, projCcoList, onValidate, projectId, activeTab }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [editableFields, setEditableFields] = useState({ description: "" });
  const [action, setAction] = useState("upload");
  const [selectedMergeItem, setSelectedMergeItem] = useState(ccoNo);

  useEffect(() => {
    if (items && items.length > 0) {
      const firstItem = items[0];
      setSelectedItem(firstItem);
      setEditableFields({ description: firstItem.description });
    }
    // Determine action type based on an existing CCO
    const existingCco = projCcoList.find(item => item.ccoNo === parseInt(ccoNo));
    setAction(existingCco ? "merge" : "upload");
    setSelectedMergeItem(existingCco?.ccoNo || projCcoList[0]?.ccoNo || null);
  }, [items, projCcoList, ccoNo]);

  const handleFieldChange = (e) => {
    setEditableFields(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSelectionChange = (e) => {
    const selectedGuid = e.target.value;
    const item = items.find(item => item.ccoGuid === selectedGuid);
    if (!item) return;
    setSelectedItem(item);
    setEditableFields({ description: item.description });
  };

  const handleActionChange = (e) => {
    setAction(e.target.value);
  };

  const handleValidate = () => {
    if (action === "upload" && !editableFields.description) {
      alert("All fields must be filled out for upload into project data");
      return;
    }

    let updatedCcos = items.map(item => ({ ...item, uploadedBy: undefined }));
    let selectedCcoGuid = selectedItem?.ccoGuid;

    if (action === "merge") {
      const matchedItem = projCcoList.find(item => item.ccoNo === parseInt(selectedMergeItem));
      if (matchedItem) {
        const mergeItem = {
          ...items[0],
          ccoGuid: matchedItem.ccoGuid,
          description: matchedItem.description,
          uploadedBy: undefined,
        };
        updatedCcos = [...updatedCcos, mergeItem];
        selectedCcoGuid = matchedItem.ccoGuid;
      }
    }

    onValidate(
      projectId,
      {
        BidItems: [],
        Ccos: updatedCcos,
        Locations: [],
        SelectedBidItemGuid: null,
        SelectedCcoGuid: selectedCcoGuid,
        SelectedLocationGuid: null,
      },
      activeTab
    );
  };

  return (
    <Card style={{ marginBottom: "1rem" }}>
      <CardBody>
        <CardTitle tag="h5">CCO #{ccoNo}</CardTitle>
        <Form>
          <FormGroup>
            <Label for={`select-${ccoNo}`}>Select</Label>
            <Input
              type="select"
              id={`select-${ccoNo}`}
              value={selectedItem?.ccoGuid || ""}
              onChange={handleSelectionChange}
            >
              {items.filter(item => !item.isValidated).map(item => (
                <option key={item.ccoGuid} value={item.ccoGuid}>
                  From {item.uploadedBy} on {new Date(item.uploadedOn).toLocaleString()}
                </option>
              ))}
            </Input>
          </FormGroup>
          {selectedItem && (
            <FormGroup>
              <Label for={`description-${ccoNo}`}>Description</Label>
              <Input
                type="text"
                id={`description-${ccoNo}`}
                name="description"
                value={editableFields.description}
                onChange={handleFieldChange}
              />
            </FormGroup>
          )}
          <FormGroup tag="fieldset" className="mt-4">
            <legend>Action</legend>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="action"
                  value="upload"
                  checked={action === "upload"}
                  onChange={handleActionChange}
                  disabled={projCcoList.some(item => item.ccoNo === parseInt(ccoNo))}
                />{" "}
                Upload Selected Item
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="action"
                  value="merge"
                  checked={action === "merge"}
                  onChange={handleActionChange}
                  disabled={projCcoList.length === 0}
                />{" "}
                Merge with Existing Item
              </Label>
              <Input
                type="select"
                id={`mergeWith-${ccoNo}`}
                value={selectedMergeItem || ""}
                onChange={(e) => setSelectedMergeItem(e.target.value)}
                disabled={action !== "merge"}
              >
                {projCcoList.map(item => (
                  <option key={item.ccoNo} value={item.ccoNo}>
                    #{item.ccoNo} - {item.description}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </FormGroup>
          <Button color="primary" onClick={handleValidate} className="mt-3">
            Validate
          </Button>
        </Form>
      </CardBody>
    </Card>
  );
};

export default CoCard;